<script>
export let type, pmt, lease, term, miles;
</script>

<style>
   .special-card {
     width: 100%;
     margin: 0 16px;
     padding: 8px 32px;
     border-radius: var(--border-radius);
     background: var(--special-background);
     text-align: center;
   }
   .special-type {
     font-weight: bold;
   }
   .special-pmt-card {
     display: flex;
     justify-content: center;
     color: var(--accent-color);
   }
   .special-pmt {
     font-weight: bold;
     font-size: 3.5rem;
   }
   .special-pmt sup {
     font-size: 2rem;
     font-weight: normal;
   }
   .special-pmt-sub {
     font-size: 1rem;
     font-weight: normal;
     margin: 1.25rem 0 0 8px;
   }
   .special-term {
     color: var(--accent-color);
     font-size: 0.85rem;
   }
</style>

<div class="special-card {lease}">
          <div class="special-type">
            {type}
          </div>
          <div class="special-pmt-card">
            <div class="special-pmt">{#if lease === 'true'}<sup>$</sup>{/if}{pmt}</div>
            { #if lease === 'true' }<div class="special-pmt-sub">/mo. <br>+ tax</div>{/if}
          </div>
          {#if term != ''}
          <div class="special-term">{#if lease === 'false'}Up To {/if}{term} Mos. { #if lease === 'true' }| {miles}k Miles{/if}</div>
          {/if}
        </div>